var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgProcessScriptTaskIcon = function SvgProcessScriptTaskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#595959",
    viewBox: "0 0 25 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.774 13.819a.52.52 0 0 0 .74 0l2.27-2.27a.524.524 0 0 0 0-.74l-2.27-2.27a.524.524 0 1 0-.74.741l1.899 1.9-1.899 1.898a.524.524 0 0 0 0 .74m4.56.153h3.141a.524.524 0 0 0 0-1.047h-3.141a.524.524 0 0 0 0 1.047",
    clipRule: "evenodd"
  })));
};
var Memo = /*#__PURE__*/memo(SvgProcessScriptTaskIcon);
export default Memo;